export default __webpack_public_path__ + "images/pending_192aa2.svg";